import { useMutation } from '@apollo/client'
import { useFlag, FF } from '@local/do-secundo-feature-flag'
import {
  useIsPasswordlessAuthEnabled,
  isPasswordlessLoggedIn
} from './passwordless-auth-utils'
import { dataByTypename } from '../../../../client/utils/apollo-helpers'
import { DELETE_ACCOUNT } from '../../index'

/**
 * Determines if the account deletion feature should be visible to a user
 */
export const useIsDeleteAccountEnabled = () => {
  const PASSWORDLESS_ENABLED =
    useIsPasswordlessAuthEnabled() && isPasswordlessLoggedIn()
  const DELETE_ACCOUNT_FF_ENABLED = useFlag(FF.DELETE_ACCOUNT)

  return PASSWORDLESS_ENABLED && DELETE_ACCOUNT_FF_ENABLED
}

/**
 * Returns a mutation function that deletes a passwordless account
 */
export const useDeleteAccount = () => {
  const [deleteAccount] = useMutation(DELETE_ACCOUNT)
  return async ({
    onSuccess,
    onError
  }: {
    onSuccess?: (e?: any) => void | any
    onError?: (e?: any) => void | any
  }) => {
    const deleteResponse = await deleteAccount()
    const { DeleteAccountResponse, DeleteAccountError } = dataByTypename(
      deleteResponse.data.deleteAccount
    )

    if (DeleteAccountResponse) {
      onSuccess && onSuccess(DeleteAccountResponse)
    } else if (DeleteAccountError) {
      onError && onError(DeleteAccountError)
    }
  }
}
